import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { getAllMyLearningActions } from "../slices";

function* getAllMyLearningWorker({ payload }) {
  //   yield delay(300);
  try {
    yield put(getAllMyLearningActions.pending());
    const response = yield call(courseAPI.getAllMyLearning, payload);
    yield put(getAllMyLearningActions.success(response));
    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(getAllMyLearningActions.failure(error));
    // TODO: handle callback | onFailure
  }
}

export { getAllMyLearningWorker };
